var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1424_2666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12H0.5C0.225 12 0 11.775 0 11.5C0 11.225 0.225 11 0.5 11H11.5C11.775 11 12 11.225 12 11.5C12 11.775 11.775 12 11.5 12ZM7.385 9.43L10.56 6.055C10.995 5.62 11.12 5 10.885 4.435C10.65 3.87 10.125 3.515 9.51 3.51H8.475L8.46 1.985C8.46 0.89 7.57 0 6.475 0H5.485C4.39 0 3.5 0.89 3.5 1.99V3.5H2.475C1.86 3.5 1.335 3.855 1.1 4.425C0.865 4.99 0.99 5.615 1.415 6.035L4.58 9.435C4.965 9.82 5.475 10.015 5.985 10.015C6.495 10.015 7 9.82 7.39 9.435L7.385 9.43ZM4 4.5C4.135 4.5 4.26 4.445 4.355 4.355C4.45 4.26 4.5 4.135 4.5 4V1.985C4.5 1.44 4.94 1 5.485 1H6.475C7.02 1 7.46 1.445 7.46 1.99L7.475 4.015C7.475 4.29 7.7 4.51 7.975 4.51H9.5C9.805 4.51 9.925 4.745 9.95 4.815C9.98 4.885 10.06 5.135 9.83 5.36L6.665 8.725C6.28 9.105 5.66 9.1 5.29 8.73L2.125 5.33C1.91 5.115 1.99 4.865 2.02 4.795C2.05 4.725 2.17 4.49 2.47 4.49H4V4.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1424_2666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconn);
export default __webpack_public_path__ + "static/media/downloadIconn.30ed0b258ef4be49d85669fb38123c4e.svg";
export { ForwardRef as ReactComponent };